import {
  B300,
  B400,
  G300,
  N900,
  R400,
  R500,
  N800
} from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const MOBILE_BREAKPOINT = '450px';
export const TABLET_BREAKPOINT = '768px';

export const SPACING_UNIT = 8;

export const fontCharlieText = `"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
export const fontCharlieDisplay = `"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont,"Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FieldWrapper = styled.div<{
  isDisabled?: boolean;
  validationState?: string;
}>`
  position: relative; // needed?
  margin: 0;
  padding: 0;

  input {
    height: 20px;
    box-sizing: content-box;
  }

  > div {
    transition: all 0.1s linear 0s;
    opacity: ${({ isDisabled }) => (isDisabled ? 0.4 : 1)};
    ${({ validationState }) =>
      validationState === 'success' && ` border-color:${G300} !important`};
    ${({ validationState }) =>
      validationState === 'error' && ` border-color:${R400} !important`};
  }
`;

const ErrorLinkStyles = css`
  text-decoration: none;
  color: ${B400};

  &:hover {
    text-decoration: underline;
    color: ${B300};
  }
`;

export const ErrorMessage = styled.div`
  font-size: 0.875rem;
  font-weight: 400;
  margin: 16px 0;
  font-size: 12px;
  line-height: 12px;
  display: grid;
  justify-items: flex-start;
  align-items: start;
  width: 100%;
  margin: 0;
  z-index: 9; // ??
  color: ${N900};
  background: transparent !important;

  & > div {
    display: flex;
  }

  span {
    margin-top: 6px;
    color: ${R400};
  }

  a {
    ${ErrorLinkStyles}
  }
`;
export const SubmitErrorMessage = styled.div`
  background: transparent !important;
  color: ${R500};
  font-family: ${fontCharlieText};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.22222222;
  margin-top: 8px;

  a {
    ${ErrorLinkStyles}
  }
`;

export const ParagraphOversized = styled.p`
  color: ${N800};
  font-family: ${fontCharlieText};
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.3px;
  line-height: 1.5;
  margin: 0px;

  & + & {
    margin-top: 12px;
  }

  @media (min-width: ${TABLET_BREAKPOINT}) {
    font-family: ${fontCharlieDisplay};
    font-size: 20px;
    line-height: 1.4;
  }
`;
